import useCanAccessFeature from '@hooks/useCanAccessFeature';

function AccessWrapper({ feature, children, fallback = null }) {
  const canAccess = useCanAccessFeature({ feature });

  if (!canAccess) {
    return fallback;
  }

  return children;
}

export default AccessWrapper;
